export default __webpack_public_path__ + "static/media/K_T_NAGARAJ.a2abcf59.JPG";